import { Text } from "@minuthq/meatball-ui-react"

import { TUserOrderDetails } from "src/data/billing/types/billingTypes"
import { countryCodeToCountry } from "src/data/countries/countryUtil"

export function OrderAddress({
  address,
}: {
  address:
    | TUserOrderDetails["shipping_address"]
    | TUserOrderDetails["billing_address"]
}) {
  return (
    <Text variant="body" color="secondary">
      <div>{`${address.first_name} ${address.last_name}`}</div>
      <div>{address.line1}</div>
      {address.line2 && <div>{address.line2}</div>}
      <div>
        {[address.city, address.state_code, address.zip]
          .filter(Boolean)
          .join(" ")}
      </div>
      <div>{countryCodeToCountry(address.country)}</div>
    </Text>
  )
}
